"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconCard3 = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var IconCard3 = function (_a) {
    var Icon = _a.Icon, title = _a.title, children = _a.children;
    return ((0, jsx_runtime_1.jsx)("div", __assign({ className: "card h-100 hover-shadow-lg text-center border" }, { children: (0, jsx_runtime_1.jsxs)("div", __assign({ className: "p-7 x5-px-5 pb-8" }, { children: [(0, jsx_runtime_1.jsx)("div", __assign({ className: "d-inline-block position-relative rounded-circle square-xl bg-dark mb-5" }, { children: (0, jsx_runtime_1.jsx)(Icon, { className: "absolute-center" }) })), (0, jsx_runtime_1.jsx)("h5", __assign({ className: "small-md ls-0-3 fw-normal mb-4" }, { children: title })), (0, jsx_runtime_1.jsx)("p", __assign({ className: "small-md fw-light lh-1-75 mb-0" }, { children: children }))] })) })));
};
exports.IconCard3 = IconCard3;
